import styles from "./Styles/Button.module.css"
import {FcGoogle} from "react-icons/fc"

function GButton(props) {
    return <div style={{marginBottom:props.mb,marginTop:props.mt}} className={styles.button}>
        <button style={{borderRadius:10, height:props.height || 50, width:'100%', color:'#111942',backgroundColor:'#fff',border:'1px solid #111942',display:'flex',alignItems:'center',gap:'10px',justifyContent:'center'}} onClick={props.onClickHandler}>
            <FcGoogle size={22} />
            <p>{props.title}</p></button>
    </div>
}

export default GButton